module.exports = __webpack_public_path__ + "static/img/Permiso(11).70a6625.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(11).jpg
// module id = x6M+
// module chunks = 0